import { z } from 'zod';

export const projectContextSchema = z.object({
  projectKey: z.string(),
  environmentKeys: z.preprocess((value) => {
    if (Array.isArray(value)) {
      return new Set(value);
    }
    if (value instanceof Set) {
      return value;
    }
  }, z.set(z.string())),
  selectedEnvironmentKey: z.string(),
  selectedViewKey: z.string().optional(),
});

export type ProjectContext = z.infer<typeof projectContextSchema>;
